export default __webpack_public_path__ + "static/mobcase3-5c7088f29b9d877c1dd45d1350bd8c27.png";